var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbLikeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12038",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h16v16H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 341",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12039",
    fill: "none",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15950",
    d: "M12.667 5.667h-2.334l.133-1.1c.2-1.633-.133-2.933-1.2-3.233h-.1a.667.667 0 0 0-.5.4S6.333 6.667 5.333 6.667H1.667A.667.667 0 0 0 1 7.333v5.333a.667.667 0 0 0 .667.667H6.1a.533.533 0 0 1 .4.133 7.292 7.292 0 0 0 2.833 1.2H11c1.967 0 3.667-1.333 3.833-3.967L15 8a2.233 2.233 0 0 0-2.333-2.333zM2.333 8h2v4h-2zM13.5 10.6c-.133 1.733-1.067 2.733-2.5 2.733H9.333A7.33 7.33 0 0 1 7.3 12.4a1.933 1.933 0 0 0-1.2-.4h-.433V8c.633-.133 1.667-.733 3.5-4.267a5.4 5.4 0 0 1-.033.7L9 5.533 8.833 7h3.833a.9.9 0 0 1 1 .967z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLikeWhite);
export default __webpack_public_path__ + "static/media/FB_like_white.81ea6c979506cc8e678e1d842624f8e0.svg";
export { ForwardRef as ReactComponent };